(function () {
  if (window.cardTapPreviewLoaded) return;
  window.cardTapPreviewLoaded = true;

  /* Phones: while a finger rests on a product photo, the card shows the product's
     other colours one after another (from its colour dots). Lifting the finger brings
     the original photo back. A normal quick tap still opens the product. */
  var CYCLE_MS = 900;
  var state = null;

  function colourImages(wrapper) {
    var list = [];
    wrapper.querySelectorAll('.card-swatches__item[data-image-src]').forEach(function (button) {
      list.push({ src: button.dataset.imageSrc, srcset: button.dataset.imageSrcset || '', button: button });
    });
    return list;
  }

  function preload(list) {
    list.forEach(function (item) {
      var img = new Image();
      img.src = item.src;
    });
  }

  function showColour(s, index) {
    var item = s.colours[index];
    if (!item) return;
    if (item.srcset) s.image.srcset = item.srcset;
    else s.image.removeAttribute('srcset');
    s.image.src = item.src;
    s.wrapper.querySelectorAll('.card-swatches__item').forEach(function (b) {
      b.classList.toggle('card-swatches__item--previewing', b === item.button);
    });
  }

  function start(wrapper) {
    stop(true);
    var image = wrapper.querySelector('.card__media .media img');
    if (!image) return;
    var colours = colourImages(wrapper);
    if (colours.length < 2) return;

    /* Start from the colour after the one showing now */
    var currentSrc = (image.currentSrc || image.src || '').split('?')[0];
    var startIndex = 0;
    colours.forEach(function (item, i) {
      var base = item.src.split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
      if (currentSrc && currentSrc.indexOf(base.split('/').pop().split('.')[0]) !== -1) startIndex = i + 1;
    });
    if (startIndex >= colours.length) startIndex = 0;

    preload(colours);
    state = {
      wrapper: wrapper,
      image: image,
      colours: colours,
      index: startIndex,
      original: { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') },
      timer: null
    };
    wrapper.classList.add('card-wrapper--colour-preview');
    showColour(state, state.index);
    state.timer = setInterval(function () {
      if (!state) return;
      state.index = (state.index + 1) % state.colours.length;
      showColour(state, state.index);
    }, CYCLE_MS);
  }

  function stop(immediate) {
    if (!state) return;
    var s = state;
    state = null;
    clearInterval(s.timer);
    var restore = function () {
      if (s.original.srcset) s.image.setAttribute('srcset', s.original.srcset);
      else s.image.removeAttribute('srcset');
      s.image.setAttribute('src', s.original.src);
      s.wrapper.classList.remove('card-wrapper--colour-preview');
      s.wrapper.querySelectorAll('.card-swatches__item--previewing').forEach(function (b) {
        b.classList.remove('card-swatches__item--previewing');
      });
    };
    if (immediate) restore();
    else setTimeout(restore, 150);
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('.card-swatches, .quick-add')) return;
      var wrapper = target.closest('.card-wrapper');
      if (!wrapper) return;
      var media = wrapper.querySelector('.card__media');
      if (!media) return;
      var touch = event.touches && event.touches[0];
      if (touch) {
        var rect = media.getBoundingClientRect();
        if (touch.clientX < rect.left || touch.clientX > rect.right || touch.clientY < rect.top || touch.clientY > rect.bottom) return;
      }
      start(wrapper);
    },
    { capture: true, passive: true }
  );

  document.addEventListener('touchend', function () { stop(false); }, { capture: true, passive: true });
  document.addEventListener('touchcancel', function () { stop(false); }, { capture: true, passive: true });

  /* Coming back with the browser's back button: show the original photos again */
  window.addEventListener('pageshow', function () { stop(true); });
})();
